import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabItem: {
      position: "relative",
      cursor: "pointer",
      opacity: "0.5",
      WebkitUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none",
      transition: "opacity 2s",
      "& :hover": {
        opacity: "1",
      },
    },
    selectedTab: {
      cursor: "pointer",
      opacity: 1,
    },
    "@keyframes pulse": {
      "0%": {
        transform: "scale(0.3)",
      },
      "100%": {
        transform: "scale(2)",
      },
    },
  })
);
